module.exports = __webpack_public_path__ + "img/birthday.6444b1b7.png";